/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export interface CreateActionPointDto {
  /** Name of the action point */
  name: string;
  /** Friendly name of the action point */
  friendlyName?: string;
}
